"use strict";

import {WealthyEnv} from "../helpers";
import {transformedAxios as axios} from "./axios";

const fetchArticles = ({contentType = "insights", limit = 1000, offset = 0} = {}) => {
  const finalURL = `${WealthyEnv.GATE_WEALTHPRESS_API_URL}/contents/?is_published=True&content_type=${contentType}&limit=${limit}&offset=${offset}`;
  return axios.get(finalURL);
};

const fetchArticlesByCategory = ({contentType = "insights", category = "", limit = 1000, offset = 0} = {}) => {
  const finalURL = `${WealthyEnv.GATE_WEALTHPRESS_API_URL}/contents/?is_published=True&content_type=${contentType}&category=${category}&limit=${limit}&offset=${offset}`;
  return axios.get(finalURL);
};

const fetchAppFaqs = async (limit = 1000) => {
  const content = [];
  try {
    const faqs = await fetchArticles({contentType: "faqs", limit}).then(result => result.data);
    for (let i = 0; i < faqs.results.length; i++) {
      const faq = {};
      faq.id = faqs.results[i].id;
      faq.title = faqs.results[i].title;
      faq.htmlContent = faqs.results[i].htmlContent;
      faq.description = faqs.results[i].description;
      faq.categories = faqs.results[i].categories;
      content.push(faq);
    }
    return content;
  } catch (err) {
    console.log(err);
    return null;
  }
};

const fetchAppArticles = async (limit = 3) => {
  const insights = [];
  try {
    const articles = await fetchArticles({contentType: "insights", limit}).then(result => result.data);
    for (let i = 0; i < articles.results.length; i++) {
      const insight = {};
      insight.id = articles.results[i].id;
      insight.title = articles.results[i].title;
      insight.subTitle = articles.results[i].subTitle;
      insight.description = articles.results[i].description;
      insight.iconUrl = articles.results[i].iconUrl;
      insight.readTime = articles.results[i].readTime;
      insight.url = `${WealthyEnv.URL}/articles/${articles.results[i].slug}-${articles.results[i].id}?utm_source=Mobile%20App&utm_medium=In-App&utm_campaign=Gray%20Matter`;
      insights.push(insight);
    }
    return insights;
  } catch (err) {
    console.log(err);
  }
};

const fetchAvailableArticleYears = ({contentType = "big-picture"} = {}) => {
  const finalURL = `${WealthyEnv.GATE_WEALTHPRESS_API_URL}/contents/years/?content_type=${contentType}`;
  return axios.get(finalURL);
};

const fetchArticlesByYear = ({year = new Date().getFullYear(), orderingField = "published_at", contentType = "money-order", limit = 1000, offset = 0} = {}) => {
  const finalURL = `${WealthyEnv.GATE_WEALTHPRESS_API_URL}/contents/?published_at=${year}&ordering=-${orderingField}&content_type=${contentType}&is_published=True&limit=${limit}&offset=${offset}`;
  return axios.get(finalURL);
};

const fetchArticlesByOrdering = ({orderingField = "-created_at", category = "", contentType = "money-order", limit = 1000, offset = 0} = {}) => {
  const finalURL = `${WealthyEnv.GATE_WEALTHPRESS_API_URL}/contents/?content_type=${contentType}&category=${category?.toLocaleLowerCase()}&ordering=${orderingField}&is_published=True&limit=${limit}&offset=${offset}`;
  return axios.get(finalURL);
};

const fetchArticleInternal = (id) => {
  const finalURL = `${WealthyEnv.GATE_WEALTHPRESS_API_URL}/contents/${id}/?is_published=True`;
  return axios.get(finalURL);
};

const fetchArticleExternal = (token, id) => {
  const config = {
    headers: {"X-W-EDIT-TOKEN": token}
  };
  const finalURL = `${WealthyEnv.GATE_EDITOR_API_URL}/contents/${id}/`;
  return axios.get(finalURL, config);
};

const fetchFaqs = (searchQuery = "") => {
  const finalURL = `${WealthyEnv.GATE_EDITOR_API_URL}/faqs/?limit=1000&offset=0&search=${searchQuery}`;
  return axios.get(finalURL);
};

const addFaq = (token, payload) => {
  const config = {
    headers: {"X-W-EDIT-TOKEN": token}
  };
  const finalURL = `${WealthyEnv.GATE_EDITOR_API_URL}/faqs/`;
  return axios.post(finalURL, payload, config);
};

const modifyFaq = (token, faqId, payload) => {
  const config = {
    headers: {"X-W-EDIT-TOKEN": token}
  };
  const finalURL = `${WealthyEnv.GATE_EDITOR_API_URL}/faqs/${faqId}/`;
  return axios.patch(finalURL, payload, config);
};

const updateFaq = (token, payload) => {
  const config = {
    headers: {"X-W-EDIT-TOKEN": token}
  };
  const finalURL = `${WealthyEnv.GATE_EDITOR_API_URL}/contents/faqs/`;
  return axios.post(finalURL, payload, config);
};

const updateArticle = (payload, token, id) => {
  const config = {
    headers: {"Content-type": "application/json",
      "X-W-EDIT-TOKEN": token}
  };
  const finalURL = `${WealthyEnv.GATE_EDITOR_API_URL}/contents/${id}/`;
  return axios.put(finalURL, payload, config);
};

const publishArticle = (token, id, publishedAt) => {
  console.log(publishedAt, "publishedAt");
  const finalURL = `${WealthyEnv.GATE_EDITOR_API_URL}/contents/${id}/publish/`;
  // if (publishedAt) {
  //   finalURL = `${WealthyEnv.GATE_EDITOR_API_URL}/contents/${id}/publish/?published_at=${publishedAt}`;
  // }
  console.log(finalURL, "finalURL");

  const config = {
    headers: {"Content-type": "application/json",
      "X-W-EDIT-TOKEN": token
    }
  };
  const payload = {};
  if (publishedAt !== null && publishedAt !== undefined) {
    payload.published_at = publishedAt;
  }

  return axios.post(finalURL, payload, config);
};

const fetchBatchContent = () => {
  const payload = [
    {
      url: "/api/v0/contents/?content_type=insights,stories,money-order&limit=1&ordering=-score&is_published=True",
      method: "get"
    },
    {
      url: "/api/v0/contents/?content_type=insights,stories,money-order&limit=6&offset=1&ordering=-score&is_published=True",
      method: "get"
    },
    {
      url: "/api/v0/contents/?content_type=insights&limit=2&is_published=True",
      method: "get"
    },
    {
      url: "/api/v0/contents/?content_type=stories&limit=2&is_published=True",
      method: "get"
    },
    {
      url: "/api/v0/contents/?content_type=money-order&limit=2&is_published=True",
      method: "get"
    }
  ];

  const finalURL = `${WealthyEnv.GATE_WEALTHY_ECS_API_URL}/api/v1/batch/`;
  return axios.post(finalURL, payload);
};

const fetchCategories = (contentType = "insights") => {
  const finalURL = `${WealthyEnv.GATE_WEALTHPRESS_API_URL}/content-categories/?content_type=${contentType}`;
  return axios.get(finalURL);
};

const fetchAuthors = () => {
  const finalURL = `${WealthyEnv.GATE_WEALTHPRESS_API_URL}/authors/`;
  return axios.get(finalURL);
};

const fetchAuthorDetail = (authorId) => {
  const finalURL = `${WealthyEnv.GATE_WEALTHPRESS_API_URL}/authors/${authorId}/`;
  return axios.get(finalURL);
};

const fetchMediaYearsDev = () => {
  const finalURL = `${WealthyEnv.WEALTHPRESS_TOOLS_BASE_URL}/public/api/v0/media/years/`;
  return axios.get(finalURL);
};

const fetchMediaData = (year, featured, limit = 10, offset = 0) => {
  const params = new URLSearchParams();
  params.set("year", String(year));
  params.set("limit", String(limit));
  params.set("offset", String(offset));
  if (featured === 1 ) {
    params.set("featured", "1");
  }
  const finalURL = `${WealthyEnv.WEALTHPRESS_TOOLS_BASE_URL}/public/api/v0/media/?${params.toString()}`;
  return axios.get(finalURL);
};


export {
  fetchAppArticles,
  fetchArticles,
  fetchAvailableArticleYears,
  fetchArticlesByYear,
  fetchArticlesByCategory,
  fetchArticlesByOrdering,
  fetchArticleInternal,
  fetchArticleExternal,
  fetchFaqs,
  addFaq,
  modifyFaq,
  updateFaq,
  updateArticle,
  publishArticle,
  fetchBatchContent,
  fetchCategories,
  fetchAppFaqs,
  fetchAuthors,
  fetchAuthorDetail,
  fetchMediaData,
  fetchMediaYearsDev,
};
